export default __webpack_public_path__ + "static/media/DailyRoutine_02.91195eaf.png";